var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5967 25.9958L14.9883 29.3958C15.555 29.9625 16.83 30.2458 17.68 30.2458H23.0633C24.7633 30.2458 26.605 28.9708 27.03 27.2708L30.43 16.9292C31.1383 14.9458 29.8633 13.2458 27.7383 13.2458H22.0717C21.2217 13.2458 20.5133 12.5375 20.655 11.5458L21.3633 7.01251C21.6467 5.73751 20.7967 4.32084 19.5217 3.89584C18.3883 3.47084 16.9717 4.03751 16.405 4.88751L10.5967 13.5292",
    stroke: "#F29999",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37158 25.9958V12.1125C3.37158 10.1292 4.22158 9.42084 6.20492 9.42084H7.62158C9.60492 9.42084 10.4549 10.1292 10.4549 12.1125V25.9958C10.4549 27.9792 9.60492 28.6875 7.62158 28.6875H6.20492C4.22158 28.6875 3.37158 27.9792 3.37158 25.9958Z",
    stroke: "#F29999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.6d079024aea8ddc354ed5d207b0079cf.svg";
export { ForwardRef as ReactComponent };